/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PagesGestioneUtenteRicercaUtenteResolver implements Resolve<Observable<any>> {

    constructor(
        private anagraficaService: AnagraficaService,
    ) { }

    resolve(): Observable<any> {
        return forkJoin([
            this.anagraficaService.getEnte(),
            this.anagraficaService.getRuolo(),
        ]).pipe(
            map(([
                responseAnagraficaEnte,
                responseAnagraficaRuolo,
            ]) => {
                return {
                    datalist: {
                        ente: responseAnagraficaEnte,
                        ruolo: responseAnagraficaRuolo,
                    },
                };
            })
        )
    }

}